<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Turnaround Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <b-form @submit.prevent="onSubmit">
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <b-card-header>
              <span class="text-muted text-uppercase"
                >Turnaround Identification</span
              >
            </b-card-header>
            <div class="py-3 px-5">
              <b-form-group label="Name" :label-cols="2">
                <b-form-input
                  type="text"
                  v-model="form_data.name"
                  placeholder="Ex. 50% Rush"
                />
              </b-form-group>
              <b-form-group label="Sample Type" :label-cols="2">
                <multiselect
                  v-model="selected_sample_type"
                  :value="sample_type_value"
                  :options="sample_type_options"
                  :multiple="false"
                  track-by="id"
                  label="name"
                />
              </b-form-group>
              <b-form-group label="Description" :label-cols="2">
                <b-form-textarea
                  v-model="form_data.description"
                  placeholder="Turnaround Description"
                />
              </b-form-group>
              <b-form-group label="Turnaround" :label-cols="2">
                <b-input-group append="Days">
                  <b-form-input
                    type="number"
                    v-model="form_data.turnaround"
                    placeholder="Turnaround (Days)"
                  />
                </b-input-group>
              </b-form-group>
              <b-form-group label="Surcharge Type" :label-cols="2">
                <multiselect
                  v-model="selected_surcharge_type"
                  :value="type_value"
                  :options="type_options"
                  :multiple="false"
                  track-by="id"
                  label="name"
                />
              </b-form-group>
              <b-form-group label="Surcharge" :label-cols="2">
                <b-input-group :prepend="surcharge_prefix">
                  <b-form-input
                    type="number"
                    v-model.number="form_data.surcharge"
                    placeholder="Surcharge Amount"
                  />
                </b-input-group>
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            @click="submitForm"
            class="my-4 float-right py-3 px-5"
            variant="success"
          >
            <i class="fal fa-address-book" /> Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "TurnaroundForm",
  components: {
    Multiselect,
  },
  props: {
    turnaround: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      loading: true,
      form_data: {
        name: null,
        description: null,
        turnaround: null,
        surcharge: null,
        surcharge_type: "flat",
        sample_type_id: null,
      },
      sample_type_value: {},
      sample_type_collection: null,
      sample_type_options: null,
      type_value: {
        id: "percent",
        name: "Percent Surcharge",
      },
      type_options: [
        {
          id: "percent",
          name: "Percent Surcharge",
        },
        {
          id: "flat",
          name: "Flat Fee",
        },
      ],
      surcharge_prefix: "$",
    };
  },
  computed: {
    selected_sample_type: {
      get() {
        return this.sample_type_value;
      },
      set(value) {
        this.sample_type_value = value;
        this.form_data.sample_type_id = value && value.id;
      },
    },
    selected_surcharge_type: {
      get() {
        return this.type_value;
      },
      set(value) {
        this.type_value = value;
        this.form_data.surcharge_type = value && value.id;
        this.surcharge_prefix = value && value.id === "flat" ? "$" : "%";
      },
    },
  },
  methods: {
    initFormData() {
      const { sample_type_id, surcharge_type } = this.turnaround;

      this.form_data = {
        ...this.turnaround.cloneAttributes(true, true, [
          "id",
          "created_at",
          "deleted_at",
          "updated_at",
          "laboratory",
          "sample_type",
        ]),
      };

      sample_type_id &&
        (this.sample_type_value = this.sample_type_options.find(
          ({ id }) => id === sample_type_id
        ));
      surcharge_type &&
        (this.type_value = this.type_options.find(
          ({ id }) => id === surcharge_type
        ));
    },
    submitForm() {
      return this.$emit("submit", this.form_data);
    },
    async init() {
      this.sample_type_collection = await getCollection({
        collection_type: "sample_type",
        sort: [
          {
            logic: "sortAddAsc",
            field: "name",
          },
        ],
        message: this.$bvToast,
      });

      this.sample_type_options = this.sample_type_collection.models.map(
        ({ id, name }) => {
          return {
            id,
            name,
          };
        }
      );

      this.turnaround && this.initFormData();

      this.loading = false;
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
